/* 🤖 this file was generated by svg-to-ts */
export const mgcIconStopCuteFi: {
  name: 'stop-cute-fi';
  data: string;
} = {
  name: 'stop-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.7 3.561c-1.829.151-2.763.489-3.636 1.319-.728.692-1.136 1.464-1.341 2.54-.17.887-.183 1.216-.183 4.58 0 2.409.013 3.341.053 3.7.172 1.556.519 2.428 1.287 3.236.855.899 1.783 1.296 3.44 1.471.703.074 6.701.076 7.353.002 1.257-.143 2.025-.378 2.703-.828a4.536 4.536 0 0 0 1.688-2.193c.353-1.036.416-1.844.416-5.388 0-1.496-.019-2.95-.042-3.26-.097-1.293-.277-2.055-.655-2.764-.227-.429-.454-.721-.848-1.096-.792-.754-1.651-1.101-3.175-1.284-.457-.055-6.455-.084-7.06-.035"/></svg>`
};
